import React from "react";
import PayPalReturnContainer from "../containers/PayPalReturn";

const PayPalReturn = () => {
  return <PayPalReturnContainer />;
};

export default PayPalReturn;
